module.exports = __webpack_public_path__ + "static/img/qrcode.94323733.png";